import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { selectIsMobile } from 'redux/modules/device';
import { decorateWith } from 'helpers/decorator';
import { localDate } from 'helpers/time';
import { shiftDateObjectByTimezone } from 'tz-offsets';
import { SEARCH } from 'constants/filter-sets';
import { filterSetFilters } from 'redux/saga/selectors';
import { deepExtract } from 'helpers/deep';
import { searchFilterActions } from './filters.helpers';
import { selectActiveLocation } from '../SearchBox/SearchBox.reducer';
import { FILTER_NAMES } from '../Search.constants';
import { DateFilter } from '../components/filters/DateFilter';
import { canSelectNextDay, getDates } from './DateFilter.helpers';

const { setFilterValue, setFilterEditing } = searchFilterActions;

const { DATE } = FILTER_NAMES;

export const mapStateToProps = state => {
  const location = selectActiveLocation(state);
  const timezone = location && location.timezone;

  const { TODAY, THIRTY_DAYS, CURRENT_MONTH, NEXT_MONTH } = getDates(timezone);

  const filters = filterSetFilters(state, SEARCH);
  const selectedDate = deepExtract('date.value', filters) || TODAY;
  const isEditing = deepExtract('date.isEditing', filters, false);

  return {
    isMobile: selectIsMobile(state),
    isSelected: selectedDate !== TODAY,
    isToday: selectedDate === TODAY,
    isNextDaySelectable: canSelectNextDay(timezone, selectedDate),
    minDate: TODAY,
    maxDate: THIRTY_DAYS,
    currentMonth: CURRENT_MONTH,
    nextMonth: NEXT_MONTH,
    selectedDate,
    timezone,
    isEditing,
  };
};

export const mapDispatchToProps = {
  onSelectDate: value =>
    setFilterValue(DATE, value, {
      resetIsEditing: true,
    }),
  onClear: timezone => setFilterValue(DATE, localDate(shiftDateObjectByTimezone(new Date(), timezone))),
  onSetIsEditing: isEditing => setFilterEditing(DATE, isEditing),
};

const DateFilterContainer = decorateWith(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(DateFilter);

export { DateFilterContainer };
